import {
  lucideBookOpen,
  lucideChevronDown,
  lucideClipboardCheck,
  lucideEye,
  lucideEyeOff,
  lucideImages,
  lucideLayoutDashboard,
  lucideLogOut,
  lucideMap,
  lucideMenu,
  lucideMessageCircleWarning,
  lucideMessageSquare,
  lucideMoon,
  lucideShieldCheck,
  lucideSignpost,
  lucideSquareChevronLeft,
  lucideSun,
  lucideUsers,
} from '@ng-icons/lucide'
import {
  tablerBrandAndroid,
  tablerBrandApple,
  tablerDeviceDesktop,
  tablerDeviceMobile,
  tablerDeviceUnknown,
} from '@ng-icons/tabler-icons'

export const appIcons = {
  lucideBookOpen,
  lucideChevronDown,
  lucideClipboardCheck,
  lucideEye,
  lucideEyeOff,
  lucideImages,
  lucideLayoutDashboard,
  lucideLogOut,
  lucideMap,
  lucideMenu,
  lucideMessageCircleWarning,
  lucideMessageSquare,
  lucideMoon,
  lucideShieldCheck,
  lucideSignpost,
  lucideSquareChevronLeft,
  lucideSun,
  lucideUsers,
  tablerBrandAndroid,
  tablerBrandApple,
  tablerDeviceDesktop,
  tablerDeviceMobile,
  tablerDeviceUnknown,
}
